import { useQuery } from '@tanstack/react-query';

import { getPrimaryAccount } from '@arrived/api_v2';
import { Account } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { useGetCurrentUserQuery } from './useGetCurrentUserQuery';
import { accountsPrimaryKeyFn } from './users.keys';

export function useGetPrimaryAccountQuery(options?: UseQueryOptions<Account>): UseQueryResult<Account> {
  const { data: currentUserState } = useGetCurrentUserQuery();

  return useQuery(accountsPrimaryKeyFn(), () => getPrimaryAccount(currentUserState?.id), {
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: (options?.enabled ?? true) && Boolean(currentUserState?.id),
  });
}
